import { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { ErrorBoundary } from './components/ErrorBoundary'
import { WebSocketProvider } from './components/WebSocketProvider'
import { NotificationProvider } from './components/notifications/NotificationProvider'
import { TooltipProvider } from './components/ui/tooltip'
import { MapsApiProvider } from './components/maps/MapsApiProvider'
import './i18n'
import './index.css'
import '@fontsource-variable/inter'
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-sans/700.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/600.css'
import '@fontsource-variable/sora'
import '@/store/directionStore'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <Suspense fallback={<div className="flex h-screen items-center justify-center"><div className="shimmer h-8 w-32 rounded" /></div>}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={150} skipDelayDuration={500}>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <NotificationProvider>
              <WebSocketProvider>
                <MapsApiProvider>
                  <App />
                </MapsApiProvider>
              </WebSocketProvider>
            </NotificationProvider>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </Suspense>
  </ErrorBoundary>,
)
